import { TableService } from './table-service';
import { ShipmentHeader } from '../../../models/shipment-header';
import { ShipmentQuery } from '../../../models/shipment-query';
import { Observable } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectShipmentsTableBusy,
    selectShipmentsTableColumns, selectShipmentsTableCount,
    selectShipmentsTablePage, selectShipmentsTableQuery, selectShipmentsTableSelection
} from '../../../store/shipments-table/shipments-table.state';
import { map } from 'rxjs/operators';
import {
    shipmentTableChangePage,
    shipmentTableMasterToggle,
    shipmentTableSort,
    shipmentTableToggle
} from '../../../store/shipments-table/shipments-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class ShipmentTableService extends TableService<ShipmentHeader, ShipmentQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectShipmentsTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return this.store.select(selectShipmentsTableColumns).pipe(
            map(columns => [ 'select', 'id', ...columns, 'focus' ])
        );
    }

    protected getCurrentPageEntriesObservable(): Observable<ShipmentHeader[]> {
        return this.store.select(selectShipmentsTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.SHIPMENT_HEADER;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectShipmentsTableSelection);
    }

    protected getTableQueryObservable(): Observable<ShipmentQuery> {
        return this.store.select(selectShipmentsTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectShipmentsTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(shipmentTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(shipmentTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(shipmentTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(shipmentTableMasterToggle());
    }

    protected getWidthBufferPx(): number {
        return super.getWidthBufferPx() + 50;
    }
}
